import * as React from "react";

import { cn } from "@/lib/utils";
import { CardDescription, CardTitle } from "./card";
import { Separator } from "./separator";

type SectionProps = React.HTMLAttributes<HTMLElement>;

const Section = React.forwardRef<HTMLElement, SectionProps>(
  ({ className, ...props }, ref) => {
    return (
      <section
        ref={ref}
        className={cn("scroll-mt-20", className)}
        {...props}
      />
    );
  }
);
Section.displayName = "Section";

type SectionHeaderProps = React.HTMLAttributes<HTMLDivElement> & {
  title: string;
  description?: string;
  withSeparator?: boolean;
};

const SectionHeader = React.forwardRef<HTMLDivElement, SectionHeaderProps>(
  (
    { className, title, description, withSeparator = true, children, ...props },
    ref
  ) => {
    return (
      <div
        ref={ref}
        className={cn("mb-4 space-y-2", className)}
        {...props}
      >
        <CardTitle className="text-lg">{title}</CardTitle>
        {description && (
          <CardDescription className="text-sm">{description}</CardDescription>
        )}
        {withSeparator && <Separator className="mt-2" />}
        {children}
      </div>
    );
  }
);
SectionHeader.displayName = "SectionHeader";

type SectionContentProps = React.HTMLAttributes<HTMLDivElement>;

const SectionContent = React.forwardRef<HTMLDivElement, SectionContentProps>(
  ({ className, ...props }, ref) => {
    return <div ref={ref} className={cn("space-y-4", className)} {...props} />;
  }
);
SectionContent.displayName = "SectionContent";

export { Section, SectionContent, SectionHeader };
